/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { getUserByToken, login } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(50, 'Password must not exceed 50 characters')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const { data: auth } = await login(values.email, values.password)
        saveAuth(auth)
        const { data: user } = await getUserByToken(auth.api_token)
        setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-3 order-2 order-lg-1">
        <div className="text-left">
          <img className="mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10" src={toAbsoluteUrl('/media/logos/RePay@2x.png')} alt="" />
        </div>
        <form
          className='form w-100'
          onSubmit={formik.handleSubmit}
          noValidate
          id='kt_login_signin_form'
        >

          <div className="text-left mb-11">

            <h1 className="text-dark fw-semibolder mb-3">Sign In</h1>

            <div className="text-gray-500 fw-semibold fs-6">Please sign in to manage the system and access admin features.
            </div>
          </div>


          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}


          <div className='fv-row mb-10'>
            <label className='form-label fs-6 fw-semibolder text-dark'>Email</label>
            <input
              placeholder='Email'
              {...formik.getFieldProps('email')}
              className={clsx(
                'form-control form-control-lg  ',
                { 'is-invalid': formik.touched.email && formik.errors.email },
                {
                  'is-valid': formik.touched.email && !formik.errors.email,
                }
              )}
              type='email'
              name='email'

              autoComplete='off'
            />
            {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <span role='alert' className='text-danger'>{formik.errors.email}</span>
              </div>
            )}
          </div>

          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>

                <label className='form-label fw-semibolder text-dark fs-6 mb-0'>Password</label>

                <Link
                  to='/auth/forgot-password'
                  className='link-primary fs-6 fw-semibolder'
                  style={{ marginLeft: '5px' }}
                >
                  Forgot Password ?
                </Link>

              </div>
            </div>
            <input
              placeholder='Password'
              type='password'
              autoComplete='off'

              {...formik.getFieldProps('password')}

              className={clsx(
                'form-control form-control-lg  ',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert' className='text-danger'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>



          <div className='text-center'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-lg btn-primary w-100 mb-5'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className='indicator-label'>Continue</span>}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>


          </div>
        </form>

      </div>
      <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2">
        <div className="d-flex flex-lg-row-fluid ">


          <div className="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100">


            <img className="mx-auto w-200px w-md-25 w-xl-150px mb-10 mb-lg-10" src={toAbsoluteUrl('/media/logos/key@2x.png')} alt="" />
            <h2 style={{ color: '#3E3E3E' }} className="fs-2px text-center mb-3">
              Passwordless sign-in</h2>
            <div style={{ color: '#333333' }} className="fs-2px fs-base text-center">Secure online
              accounts with OneAuth 2FA.
              Back up OTP secrets and never lose access to your accounts.
            </div>

          </div>

        </div>

      </div>
    </div>
  )
}
